import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    headerImageMap: Object,
  };

  connect() {
    console.log("Card Image Modal Controller connected");
    // Default mapping of headers to images
    this.headerImageMapValue = {
      "Patient Information": "patient_info.jpg",
      "Background Information": "background_info.svg",
      "Physical Assessment": "physical_assessment.svg",
      "Vital Signs": "vital_signs.svg",
      Labs: "labs.svg",
      "Simulation Flow": "simulation_flow.svg",
      Attachments: "attachments.svg",
      "Scenario Setup": "scenario_setup.svg",
      "Attach Rating Tools": "rating_tools.svg",
      "Attach Competencies": "competencies.svg",
      "Incident Confederate": "incident_confederate.jpg",
      "Call Information": "call_info.jpg",
      "Incident Candidate": "incident_candidate.jpg",
      "Partner Prompts": "partner_prompts.jpg",
      "Incident Synopsis": "incident_synopsis.jpg",
      "Dispatch Data": "dispatch_data.jpg",
      "Narrative Medical History": "narrative_medical_history.jpg",
      Allergies: "allergies.jpg",
      Medications: "medications.jpg",
      "Past History": "listed_medical_history.jpg",
      "Patch Orders": "patch_orders.jpg",
      Course: "course.jpg",
      Expected: "expected.jpg",
      Discussion: "discussion.jpg",
      "Scenario Setup": "scenario_setup.jpg",
    };
  }

  showImage(event) {
    console.log("showImage", event.currentTarget);
    event.preventDefault();
    console.log("Full dataset:", event.currentTarget.dataset);
    console.log("Dataset keys:", Object.keys(event.currentTarget.dataset));
    const header = event.currentTarget.dataset.title;
    console.log("Header from data-title:", header);
    const imageName = this.headerImageMapValue[header];

    if (imageName) {
      console.log("Found image:", imageName);
      const modal = document.getElementById("helpImageModal");
      const image = modal.querySelector("img");
      if (modal && image) {
        image.src = `/assets/help/${imageName}`;
        const bsModal = new bootstrap.Modal(modal);
        bsModal.show();
      } else {
        console.error("Modal or image element not found");
      }
    } else {
      console.log("No image found for header:", header);
    }
  }

  hideImage(event) {
    event.preventDefault();
    const modal = document.getElementById("helpImageModal");
    if (modal) {
      // Remove the 'show' class and set display to none
      modal.classList.remove("show");
      modal.style.display = "none";
      // Remove the modal-open class from the body
      document.body.classList.remove("modal-open");
      // Remove the modal backdrop
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) {
        backdrop.remove();
      }
    }
  }
}
